export default function () {
  return {
    prospek_banks: [],
    detail: {},
    form: {},
    probabilities: [],
    probabilityActivities: [],
    pbSort: {
      sortBy: 'est_close',
      sortDesc: true
    },
    contractOptions: [
      // {
      //   id: 0,
      //   label: 'None'
      // },
      {
        id: 1,
        label: 'RR'
      },
      {
        id: 2,
        label: 'Sold'
      },
      // {
      //   id: 4,
      //   label: 'CPRR'
      // },
      // {
      //   id: 5,
      //   label: 'Sewa'
      // },
      {
        id: 6,
        label: 'B2B (Forecast by SINE)'
      }
    ],
    year: [],
    month: [],

    pbStatuses: [],
    pbStatusForm: null,
    notifs: []
  }
}
